export default "__VITE_ASSET__6PpYmDbo__"